<div class="relationship-list-container" loading-spin [isLoading]="isReloading" [loadingSize]="'big'">
    <edit-relationship-dialog></edit-relationship-dialog>
    <div class="no-data" [style.display]="noDataStyle">
        <span>No Data Found</span>
    </div>
    <div class="header-container">
        <div class="row-container">
            <div class="buttonholder">
                <button tam-button [tamType]=" 'primary' " [tamSize]=" 'normal' " class='admin-page-btn'
                    (click)="onButtonClick()">
                    {{relationshipPage?.additionalActions?.create?.buttonName}}
                </button>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="gridster-item-content">
            <ag-grid-angular class="ag-theme-balham" [columnDefs]="columnDefs"
                style="width: 100%; height: 100%;-webkit-touch-callout: default;" [rowData]="rowData"
                [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" (cellContextMenu)="onContextMenu($event)"
                (contextmenu)="suppressDefaultContextMenu($event)"
                (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
                (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
                (columnEverythingChanged)="onColumnEverythingChanged($event)">
            </ag-grid-angular>
        </div>
        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    </div>
</div>